import { render } from "./InstallPWA.vue?vue&type=template&id=d0fd3d66"
import script from "./InstallPWA.vue?vue&type=script&lang=js"
export * from "./InstallPWA.vue?vue&type=script&lang=js"

import "./InstallPWA.vue?vue&type=style&index=0&id=d0fd3d66&lang=css"

import exportComponent from "D:\\Proyectos\\Erp Con api propia\\ERP CON MI-API\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__